function customValidator(value: unknown, formData: unknown, callback: (value: unknown, formData?: unknown) => boolean) {
  return callback(value, formData);
}

export default customValidator;
